import { Grid2, Typography } from "@mui/material";

const BillingInformation = ({ formData }) => {
  const billingInfoLabels = {
    recipientType: "Recipient Type",
    billingContactFirstName: "Billing Recipient First Name",
    billingContactLastName: "Billing Recipient Last Name",
    billingContactPhone: "Billing Recipient Phone",
    billingContactEmail: "Billing Recipient Email",
    billingStreetAddress: "Street Address",
    billingCity: "City",
    billingState: "State",
    billingZipCode: "Zip Code",
    sendMethod: "How should bills be sent?",
  };
  const billingRecipientTypeEnumMap = {
    client: "Client",
    authorizedContact: "Other",
  };
  return (
    <>
      <Typography variant="h4" color="default.main">
        Billing Information
      </Typography>
      <Grid2 container spacing={3} mt={3}>
        {/* Loop over all fields in the merged billingInfoLabels */}
        {Object.entries(billingInfoLabels).map(([key, label]) => {
          const value = formData?.billingInfoSection0?.[key];
          if(key !== "recipientType" && key !== "sendMethod" && formData?.billingInfoSection0?.["recipientType"] !== "authorizedContact"){
            return null;
          }
          return (
            value && 
            <Grid2 size={{ xs: 12, sm: 6 }} key={key}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                {label}
              </Typography>
              <Typography variant="body1" color="default.light">
                {label === "Recipient Type" ? billingRecipientTypeEnumMap[value] : value || "-"}
              </Typography>
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};
export default BillingInformation;